
























































import {Component, Emit, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import dicts_cache_service from "@/services/dicts_cache_service";
import {Period} from "@/services/models-service";
import {getImbalanceStyleColor} from "@/utils/getImbalanceStyleColor";
import NumberSpan from '@/components/InputComponents/number-span.vue';

@Component({
  name: 'ImbalanceTable',
  methods: {getImbalanceStyleColor},
  components: {NumberSpan}
})
export default class extends Vue {
  @Prop({required: true}) public periods: any;
  @Prop({required: true}) public imbalanceData!: any;
  @Prop({type: [String, Number], default: '100%'}) readonly width!: string | number;
  @Prop() public cutName!: string;
  @Prop() public columnWidth: number

  public displayPeriod: any = [];

  get computedWidth(): string {
    if (typeof this.width === 'number') {
      return `${this.width - 1}px`;
    }
    return this.width;
  }

  mounted() {
    this.displayPeriod = dicts_cache_service.periods;
  }

  public getDisplayPeriodName(periodName: string): string {
    const periodObject = this.displayPeriod.find((p: Period) => p.name === periodName);
    return periodObject ? periodObject.display : '';
  }

  getImb(period: string | number, idx: number, fallback = 0) {
    const d = this.imbalanceData;
    const v = d && d[period] ? d[period][idx] : undefined;
    return Number.isFinite(v) ? v : fallback;
  }

  getImbColor(kind: string, period: string | number, idx: number) {
    return getImbalanceStyleColor(kind, this.getImb(period, idx));
  }

  fmt(v: number) {
    return Number.isFinite(v) ? v.toFixed(2).replace('.', ',') : '0,00000';
  }
}
